const guiColors = {
    'motion-primary': '#0099ff',
    'motion-primary-transparent': '#0099ffe6',
    'motion-tertiary': '#0066ff',

    'looks-secondary': '#0099ff',
    'looks-transparent': '#0077aa59',
    'looks-light-transparent': '#00669926',
    'looks-secondary-dark': '#4e97b7ff',

    'extensions-primary': '#5a8ff2ff',
    'extensions-tertiary': 'hsla(197, 85%, 40%, 1.00)',
    'extensions-transparent': '#5abdf259',
    'extensions-light': 'hsla(213, 58%, 85%, 1.00)',

    'drop-highlight': '#8cd3ffff'
};

const blockColors = {
    checkboxActiveBackground: '#0099ff',
    checkboxActiveBorder: '#0066ff'
};

export {
    guiColors,
    blockColors
};
